import React, { useEffect, useMemo, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { Search } from "react-bootstrap-table2-toolkit";
import toast from "react-hot-toast";
import { connect, useDispatch } from "react-redux";
import { Button, Card, CardBody, Col, Container, Input, Row } from "reactstrap";
// import * as loadPlansActionTypes from "../../store/LoadPlans/actionTypes";
import * as inboundActionTypes from "../../store/Inbound/actionTypes";

//Import Breadcrumb
import { useFormik } from "formik";
import { MultiSelect } from "react-multi-select-component";
import { Link, useHistory } from "react-router-dom";
import Loader from "../../common/Loader";
import Columns from "./Columns";

import { sizePerPageList } from "../Utility/sizePerPageList";
import "./styles.css";
import AutoLogout from "../Authentication/AutoLogout";
import { useSelector } from "react-redux";

import { createFilter } from "react-windowed-select";
import IncloudIcon from "../Icons/IncloudIcon";
import AsignarAsociarDocuments from "./Modals/AsignarAsociarDocuments";
import AsociarDocumentoGuardar from "./Modals/AsociarDocumentoGuardar";
import ControlVisualAsociarDoc from "./Modals/ControlVisualAsociarDoc";
import ControlVisualPrincipal from "./Modals/ControlVisualPrincipal";
import ReactivarViaje from "./Modals/ReactivarViaje";
import DesasociarViaje from "./Modals/DesasociarViaje";
import {
  idAdministrador,
  idTransportista,
  idVisualizador,
} from "../Utility/roles";

const List = ({
  list,
  getAll,
  fetching,
  mustBeUpdated,
  getAllDocumentsSTates,
  documentStates,
  role,
  download,
  carrierCode,
  filter,
  setFilter,
  clearFilter,
  activate,
  getAllAssigned,
  getAllNotAssigned,
  notassigned,
  assigned,
  postSaveAssigned,
  documentPageType,
  getAllPageType,
  fetchProccess,
  documentProccess,
  postSaveAttachs,
  assignedForDocumentId,
  getAllAssignedForDocumentId,
  fetchingEyes,
  postSaveApproval,
  postSaveReactive,
  exportAllDocument,
  disassociateService,
  getRejectionReasonAll,
  rejectionReason,
}) => {
  const history = useHistory();
  const inputFile = useRef(null);
  const user = useSelector((state) => state.Login?.user);
  const [SelectedReactivarViajeId, setSelectedReactivarViajeId] = useState(null);
  const [ShowReactivarViaje, setShowReactivarViaje] = useState(false);
  const [ShowDesasociarViaje, setShowDesasociarViaje] = useState(false);
  const [ShowAssociateDocument, setShowAssociateDocument] = useState(false);
  const [ShowAsignarInbound, setShowAsignarInbound] = useState(false);
  const [ShowOpenDocument, setShowOpenDocument] = useState(false);
  const [SelectedObjectDocument, setSelectedObjectDocument] = useState(null);
  const [ShowOpenDocument2, setShowOpenDocument2] = useState(false);
  const [SelectedObjectDocument2, setSelectedObjectDocument2] = useState(null);
  const [ListTypeDocument, setListTypeDocument] = useState([]);
  const [SelectedDocumentNumber, setSelectedDocumentNumber] = useState(null);

  const [SelectedDocumentNumberFilter, setSelectedDocumentNumberFilter] = useState(null);
  const [SelectedAsociarDocumento, setSelectedAsociarDocumento] =  useState(null);
  const [ListAsociarDocumento, setListAsociarDocumento] = useState([]);
  const [ValidAsociarDocumento, setValidAsociarDocumento] = useState({});
  const [ListAsociarDocumentoProcesar, setListAsociarDocumentoProcesar] = useState({});
  const [SelectAsociarDocumentoProcesar, setSelectAsociarDocumentoProcesar] = useState(null);

  const [CurrentPage, setCurrentPage] = useState(1);
  const [SelectedFile, setSelectedFile] = useState(null);
  const [SortOrder, setSortOrder] = useState({ sortField: null, sortOrder: null, });
  const [StateId, setStateId] = useState(filter?.StateId ?? []);
  const [DocumentStatesOptions, setDocumentStatesOptions] = useState([]);
  //Tabla 1

  const [pageSize, setPageSize] = useState(10);
  const [PageOptions, setPageOptions] = useState({
    // hideSizePerPage: true,
    // sizePerPage: list?.pageSize ?? 0,
    showTotal: true,
    totalSize: list?.rowCount ?? 0,
    page: list?.currentPage ?? 1,
    active: true,
    sizePerPageList: sizePerPageList,
    paginationTotalRenderer: (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Mostrando {from} a {to} de {size} Resultados
      </span>
    ),
  });

  // Tabla 2

  const [currentPage2, setCurrentPage2] = useState(1);
  const [pageSize2, setPageSize2] = useState(5);

  const [currentPage3, setCurrentPage3] = useState(1);
  const [pageSize3, setPageSize3] = useState(5);

  const [currentPage4, setCurrentPage4] = useState(1);
  const [pageSize4, setPageSize4] = useState(5);

  const handlePageChange3 = (type, { page, searchText }) => {
    setCurrentPage3(page);
  };

  const handlePageChange2 = (type, { page, searchText }) => {
    setCurrentPage2(page);
  };

  const handlePageChange4 = (type, { page, searchText }) => {
    setCurrentPage4(page);
  };

  const getPageData3 = () => {
    const start3 = (currentPage3 - 1) * pageSize3;
    const end3 = start3 + pageSize3;
    return ListAsociarDocumento.slice(start3, end3);
  };

  const getPageData2 = () => {
    const start2 = (currentPage2 - 1) * pageSize2;
    const end2 = start2 + pageSize2;
    return ListAsociarDocumentoProcesar?.attachs?.slice(start2, end2);
  };
  const getPageData4 = () => {
    const start4 = (currentPage4 - 1) * pageSize4;
    const end4 = start4 + pageSize4;
    if (assignedForDocumentId) {
      return assignedForDocumentId?.attachs
        ?.sort((a, b) => a.page - b.page)
        ?.slice(start4, end4);
    } else {
      return [];
    }
  };

  const handleSizePerPageChange3 = (newSizePerPage, _page) => {
    setPageSize3(newSizePerPage);
  };

  function handleSizePerPageChange2(newSizePerPage, _page) {
    setPageSize2(newSizePerPage);
  }

  function handleSizePerPageChange4(newSizePerPage, _page) {
    setPageSize4(newSizePerPage);
  }

  const handleControl = (pcId) => {
    history.push(`/outbound/control/${pcId}`);
  };

  const transformedOptions = useMemo(() => {
    if (notassigned === undefined) {
      return [];
    }

    return notassigned.map((item) => ({
      label: item?.nroDocument,
      value: item?.id,
    }));
  }, [notassigned]);

  const transformedOptionsAsociarDocumento = useMemo(() => {
    if (assigned === undefined) {
      return [];
    }

    return assigned.map((item) => ({
      label: item?.nroDocument,
      value: item?.assignedId,
      isIrch: item?.isIrch
    }));
  }, [assigned]);

  const handleAgregarAsociarDocumento = () => {
    const documentoAsociado = notassigned?.find(
      (value) => value.id === SelectedAsociarDocumento?.value
    );

    const validarListado = ListAsociarDocumento?.some(
      (value) => value?.id === SelectedAsociarDocumento?.value
    );

    if (documentoAsociado && validarListado == false) {
      setListAsociarDocumento([...ListAsociarDocumento, documentoAsociado]);
    } else {
      toast.error(
        `El documento ${SelectedAsociarDocumento?.label} ya existe en el listado.`
      );
    }
    setSelectedAsociarDocumento(null);
  };

  const handleRemoveDocumentoAsignado = (e) => {
    if (ListAsociarDocumento.length > 0) {
      let resultado = ListAsociarDocumento.filter(
        (value) => value?.id !== e.id
      );
      setListAsociarDocumento(resultado);
    }
  };
  const handleProcesarAsociarDocumento = () => {
    try {
      if (ListAsociarDocumento.length > 0) {
        const transformarData = ListAsociarDocumento?.map((value) => ({
          documentId: value.id,
          userId: user?.id,
        }));

        postSaveAssigned(transformarData);
        setListAsociarDocumento([]);
        setShowAsignarInbound(false);
      }
    } catch (error) {}
  };

  const handleDesasociarDocumento = (id) => {
    setSelectedReactivarViajeId(null);
    setSelectedReactivarViajeId(id);
    setShowDesasociarViaje(true);
  };
  useEffect(() => {
    if (ShowAsignarInbound == false) {
      setSelectedAsociarDocumento(null);
      setListAsociarDocumento([]);
    }
  }, [ShowAsignarInbound]);

  useEffect(() => {
    setCurrentPage(1);
    getAll({
      PageSize: pageSize,
      PageNumber: 1,
      carrierCode: carrierCode,
      orderColumn: SortOrder?.orderColumn,
      orderType: SortOrder?.orderType,
      ...formikFilter.values,
    });
    // getUsers({ typeId: -4 });

    return () => {};
  }, [history, carrierCode]);

  useEffect(() => {
    mustBeUpdated && setCurrentPage(1);
    getAll({
      PageSize: pageSize,
      PageNumber: 1,
      carrierCode: carrierCode,
      orderColumn: SortOrder?.orderColumn,
      orderType: SortOrder?.orderType,
      ...formikFilter.values,
      stateId: StateId?.map((x) => x.value) ?? [],
    });
  }, [mustBeUpdated, carrierCode]);

  const handleDownload = () => {
    exportAllDocument({
      PageNumber: CurrentPage,
      PageSize: pageSize,
      carrierCode: carrierCode,
      ...formikFilter.values,
      orderColumn: SortOrder?.orderColumn,
      orderType: SortOrder?.orderType,
      ...formikFilter.values,
      stateId: StateId?.map((x) => x.value) ?? [],
    });
  };
  const handleAsignar = () => {
    getAllNotAssigned();
    setShowAsignarInbound(!ShowAsignarInbound);
  };

  useEffect(() => {
    getAllDocumentsSTates({ type: 1 });
  }, []);

  useEffect(() => {
    setDocumentStatesOptions(
      documentStates.map((x) => ({ value: x.id, label: x.name }))
    );
  }, [documentStates]);

  const formikFilter = useFormik({
    initialValues: filter,
    onSubmit: (values) => {
      setFilter({
        NroDocument: "",
        ProviderName: "",
        remittanceNumber: "",
        DateFrom: "",
        DateTo: "",
        documentType: "",
      });
      setCurrentPage(1);
      getAll({
        ...values,
        PageNumber: 1,
        PageSize: pageSize,
        carrierCode: carrierCode,
        stateId: StateId?.map((x) => x.value) ?? [],
        orderColumn: SortOrder?.orderColumn,
        orderType: SortOrder?.orderType,
      });
    },
    enableReinitialize: true,
  });

  const handleKeypress = (e) => {
    //it triggers by pressing the enter key
    if (e.code === "Enter") {
      formikFilter.handleSubmit();
    }
  };

  const handleClearFilter = () => {
    clearFilter();
    setFilter({
      NroDocument: "",
      ProviderName: "",
      remittanceNumber: "",
      DateFrom: "",
      DateTo: "",
      documentType: "",
    });
    setStateId([]);
    formikFilter.setValues({});
  };
  const handleView = (id) => {
    history.push(`outbound/files/${id}`);
  };

  const handleActivate = (id) => {
    let res = window.confirm("¿Desea re-activar el plan de carga?");
    if (res) {
      activate({ id });
    }
  };

  const handleReactivarViaje = (id) => {
    setSelectedReactivarViajeId(null);
    setSelectedReactivarViajeId(id);

    setShowReactivarViaje(true);
  };
  const handleValorizate = (id, number) => {
    history.push(`outbound/prevalue/${id}/${number}`);
  };

  useEffect(() => {
    setPageOptions({
      hideSizePerPage: true,
      sizePerPage: pageSize,
      showTotal: true,
      totalSize: list?.rowCount ?? 0,
      page: list?.currentPage ?? 1,
      active: true,
      // sizePerPageList: sizePerPageList,
      paginationTotalRenderer: (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
          Mostrando {from} a {to} de {size} Resultados
        </span>
      ),
      // onSizePerPageChange: handleSizePerPageChange,
    });

    const addDataLabelManually = () => {
      const table = document.querySelector(".tableResponsiveOutbound2");

      if (table) {
        // Obtener todas las filas en el cuerpo de la tabla
        const rows =
          table.getElementsByTagName("tbody")[0]?.getElementsByTagName("tr") ??
          [];

        // Obtener todas las columnas del encabezado
        const headerCells = table.querySelectorAll("thead tr th");

        // Iterar sobre las filas
        for (let i = 0; i < rows.length; i++) {
          // Obtener todas las celdas en la fila
          const cells = rows[i].getElementsByTagName("td");

          // Iterar sobre las celdas y agregar manualmente el atributo data-label
          for (let j = 0; j < cells.length; j++) {
            // Obtener el nombre de la columna desde el encabezado
            const columnName = headerCells[j].textContent.trim();

            // Establecer manualmente el atributo data-label en la celda
            cells[j].setAttribute("data-label", columnName.replace("↕", ""));
          }
        }
      }
    };

    // Llamar a la función para agregar atributos data-label después de que el componente se haya montado
    setTimeout(() => {
      addDataLabelManually();
    }, 1000);
  }, [list.data]);

  const handlePageChange = (style, values) => {
    const { sortField, sortOrder } = values ?? {};

    let order = {
      orderColumn:
        sortField && typeof sortField === "string"
          ? sortField.slice(0, 1).toUpperCase() + sortField.slice(1)
          : "",
      orderType: sortOrder,
    };
    setSortOrder(order);

    setCurrentPage(values?.page);
    getAll({
      pageNumber: values?.page,
      PageSize: pageSize,
      carrierCode: carrierCode,
      ...formikFilter.values,
      stateId: StateId?.map((x) => x.value) ?? [],
      orderColumn: order?.orderColumn,
      orderType: order?.orderType,
    });
  };

  const handleOpenDocument = (obj) => {
    setSelectedObjectDocument(null);
    if (fetchingEyes) {
      //Si esta en feching que no llame a un boton hasta que el feching este en false
      return;
    }
    let validacionPermisos =
      role.id === idTransportista
        ? true
        : !(obj?.estado == "Completo" || obj?.estado == "Aceptado");
    //Esta activado o desactivado el boton
    if (validacionPermisos) {
      //Si esta activado que no haga nada los campos de abajo
      return;
    }

    // assignedForDocumentId,
    getAllAssignedForDocumentId({
      DocumentId: obj?.id,
      setShowOpenDocument: (variable) => setShowOpenDocument(variable),
    });

    setSelectedObjectDocument({
      ...obj,
      userId: user?.id,
      observation: "",
      valueTypeMensajeRechazo: null,
    });
  };

  const handleOpenDocument2 = (obj) => {
    setShowOpenDocument2(!ShowOpenDocument2);
    setSelectedObjectDocument2(null);
    setSelectedObjectDocument2(obj);
  };

  const handleSelectedtypeDocument = (seleccionado, row) => {
    setSelectAsociarDocumentoProcesar(null);
    setSelectAsociarDocumentoProcesar({ ...seleccionado, ...row });
  };

  const handleClearAsociarDocumentoProcesar = () => {
    setSelectedDocumentNumber(null);
    setSelectedDocumentNumberFilter(null);
    setSelectAsociarDocumentoProcesar(null);
    setListAsociarDocumentoProcesar({
      attachs: [],
      allRequired: null,
      TypesRequired: null,
    });
    setListTypeDocument(ListTypeDocument);
    setSelectedObjectDocument2(null);
    setSelectedFile(null);
    if (inputFile.current) {
      inputFile.current.value = "";
      inputFile.current.type = "text";
      inputFile.current.type = "file";
    }
    setValidAsociarDocumento({});
    setPageSize2(5);
    setCurrentPage2(1);
  };

  useEffect(() => {
    if (SelectAsociarDocumentoProcesar) {
      // Actualizar la lista basada en la condición
      let updatedList = ListAsociarDocumentoProcesar?.attachs.map((values) => {
        if (values.indice == SelectAsociarDocumentoProcesar.indice) {
          return {
            ...values,
            documentPageTypeNumber: SelectAsociarDocumentoProcesar.value,
          };
        } else {
          return values;
        }
      });

      setListAsociarDocumentoProcesar({ attachs: [] });
      setListAsociarDocumentoProcesar({
        ...ListAsociarDocumentoProcesar,
        attachs: updatedList,
      });
    }
  }, [SelectAsociarDocumentoProcesar]);

  useEffect(() => {
    if (SelectAsociarDocumentoProcesar) {
      IrchLogica();
      const allRequired = !validaterSelectionTypeDocument();
      const TypesRequired = !validateTypesRequiredDocuments();
      const nameTypeRequired = documentPageType
        .filter((item) => item.isRequired)
        .map((item) => item.name)
        .join(", ");

      setValidAsociarDocumento({
        ...ValidAsociarDocumento,
        allRequired,
        TypesRequired,
        nameTypeRequired,
      });
    }
  }, [
    SelectAsociarDocumentoProcesar,
    documentPageType,
    ListAsociarDocumentoProcesar,
  ]);

  const handleShowAssociateDocument = () => {
    getAllAssigned({ userId: user?.id });
    setShowAssociateDocument(!ShowAssociateDocument);
  };

  const handleFileChange = (event, setSelectedFile) => {
    const file = event.target.files[0];

    if (file && file.type === "application/pdf") {
      setSelectedFile(file);
    } else {
      // El archivo no es un PDF, puedes mostrar un mensaje de error o realizar otras acciones
      alert("Por favor, selecciona un archivo PDF.");
      // Restablece el input de archivo
      setSelectedFile(null);
      event.target.value = null;
    }
  };

  const handleAsociarDocumentoProcesar = () => {
    if (!SelectedDocumentNumber || !SelectedFile) {
      toast.error(
        "Es necesario seleccionar un numero de documento y subir un archivo .pdf"
      );
      return;
    }
    setSelectedDocumentNumber(null);
    setSelectedFile(null);
    if (inputFile.current) {
      inputFile.current.value = "";
      inputFile.current.type = "text";
      inputFile.current.type = "file";
    }
    setSelectedDocumentNumberFilter(null);
    setSelectedDocumentNumberFilter(SelectedDocumentNumber);
    if (SelectedDocumentNumber && SelectedDocumentNumber.isIrch) {
      SelectedFile.isIrch = SelectedDocumentNumber.isIrch;
    }
    IrchLogica();
    fetchProccess(SelectedFile);
    getAllPageType(); 
  };
  useEffect(() => {
  }, [ListTypeDocument]); // Dependencias: ListTypeDocument y SelectedDocumentNumberFilter

useEffect(() => {
  // Llamamos a la lógica de Irch solo cuando haya cambios en SelectedDocumentNumberFilter
  if (SelectedDocumentNumberFilter) {
    IrchLogica();
  }
}, [SelectedDocumentNumberFilter]); // Solo depende de SelectedDocumentNumberFilter

// Definición de la función IrchLogica
const IrchLogica = () => {
  if (SelectedDocumentNumberFilter && SelectedDocumentNumberFilter.isIrch) {
    if (documentPageType && Array.isArray(documentPageType) && documentPageType.length > 0) {
      documentPageType = documentPageType.filter(
        (item) =>
          item.id !== `${process.env.REACT_APP_DOCUMENT_PAGE_TYPE_TICKET}` &&
          item.id !== `${process.env.REACT_APP_DOCUMENT_PAGE_TYPE_IRCH}`
      );
    }

    // Solo actualizamos ListTypeDocument si realmente ha cambiado
    if (Array.isArray(ListTypeDocument) && ListTypeDocument.length > 0) {
      const listaFiltrada = ListTypeDocument.filter(
        (item) =>
          item.value !== `${process.env.REACT_APP_DOCUMENT_PAGE_TYPE_TICKET}` &&
          item.value !== `${process.env.REACT_APP_DOCUMENT_PAGE_TYPE_IRCH}`
      );

      // Comparar antes de actualizar
      if (JSON.stringify(ListTypeDocument) !== JSON.stringify(listaFiltrada)) {
        setListTypeDocument(listaFiltrada);
      }
    }
  }
};

  

  useEffect(() => {
    if (documentProccess) {
      const documentPageTypeNumber = documentProccess.map((value, index) => ({
        ...value,
        pageTypeId: null,
        documentPageTypeNumber: null,
        indice: index,
      }));

      let documentTypeNumberJson = {
        assignedId: null,
        path: documentProccess[0]?.path,
        observation: "",
        attachs: documentPageTypeNumber,
      };

      setListAsociarDocumentoProcesar(documentTypeNumberJson);
      setValidAsociarDocumento({ allRequired: true, TypesRequired: true });
    }
  }, [documentProccess]);
  useEffect(() => {
   /* if (documentPageType) {
      setListTypeDocument(
        documentPageType.map((x) => ({ value: x.id, label: x.name }))
      );
    } );
    }*/
      if (documentPageType) {
        const mappedList = documentPageType.map((x) => ({ value: x.id, label: x.name }));
        if (SelectedDocumentNumberFilter && SelectedDocumentNumberFilter.isIrch && Array.isArray(mappedList)) {
          const listaFiltrada = mappedList.filter(
            (item) =>
              item.value !== `${process.env.REACT_APP_DOCUMENT_PAGE_TYPE_TICKET}` &&
              item.value !== `${process.env.REACT_APP_DOCUMENT_PAGE_TYPE_IRCH}`
          );
          setListTypeDocument(listaFiltrada);
        } else {
          setListTypeDocument(mappedList);
        }
      }
      
  }, [documentPageType]);

  const validateTypesRequiredDocuments = () => {
    let TypesRequired = documentPageType.every((r) => {
      const attachment = ListAsociarDocumentoProcesar?.attachs.find(
        (a) => a.documentPageTypeNumber === r.id
      );
      return (attachment && r.isRequired) || (!attachment && !r.isRequired);
    });

    return TypesRequired;
    
  }
  const validaterSelectionTypeDocument = () => {
    return ListAsociarDocumentoProcesar?.attachs?.length > 0
      ? ListAsociarDocumentoProcesar?.attachs
          ?.map((item) => item.documentPageTypeNumber)
          .every((valor) => valor !== null)
      : false;
  };

  const handleGuardarAsociacionDocument = () => {
    IrchLogica();
    const todosSeleccionados = !validaterSelectionTypeDocument();
    const documentsRequired = !validateTypesRequiredDocuments();

    if (todosSeleccionados === true && documentsRequired ===true) {
      return;
    }

    const listAttachs = ListAsociarDocumentoProcesar?.attachs?.map((value) => {
      const json = {
        page: value?.page,
        pageTypeId: value?.documentPageTypeNumber,
      };

      return json;
    });

    const procesar = {
      ...ListAsociarDocumentoProcesar,
      assignedId: SelectedDocumentNumberFilter?.value,
      attachs: listAttachs,
      isIrch: SelectedDocumentNumberFilter?.isIrch,
    };

    postSaveAttachs({
      procesar,
      handleClearAsociarDocumentoProcesar: () =>
        handleClearAsociarDocumentoProcesar(),
      setShowAssociateDocument: (e) => setShowAssociateDocument(e),
    });
  };

  const handleAceptarDocument = (tipo) => {
    if (
      (role.id !== idAdministrador || role.id !== idVisualizador) &&
      SelectedObjectDocument?.estado !== "Completo"
    )
      return;

    let { userId, observation, valueTypeMensajeRechazo } =
      SelectedObjectDocument ?? {};
    let newObject = {
      assignedId: assignedForDocumentId?.assignedId,
      userId,
    };

    // TODO: tipo 1 = Aceptar y tipo 2 = Rechazar
    if (tipo === 1) {
      postSaveApproval({
        ...newObject,
        isAproval: true,
        setShowOpenDocument: (variable) => setShowOpenDocument(variable),
      });
      setSelectedObjectDocument(null);
    }
    if (tipo === 2) {
      if (!valueTypeMensajeRechazo) {
        toast.error(`Es obligatorio seleccionar un tipo de rechazo.`);
        return;
      }

      postSaveApproval({
        ...newObject,
        isAproval: false,
        observation,
        rejectionReasonId: valueTypeMensajeRechazo,
        setShowOpenDocument: (variable) => setShowOpenDocument(variable),
      });
      setSelectedObjectDocument(null);
    }
  };

  return (
    <React.Fragment>
      <AutoLogout /> {/* Activa el cierre de sesión por inactividad */}
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs="12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">{`Inbound`}</h4>

                <div className="page-title-right">
                  <Link className="btn btn-light" to={"/dashboard"}>
                    {" "}
                    <i className="mdi mdi-keyboard-backspace me-2"></i> Volver
                  </Link>{" "}
                  {role.id === idTransportista && (
                    <>
                      <Button onClick={handleAsignar} color="primary">
                        <i className="mdi mdi-link-variant"></i> Asignar
                      </Button>{" "}
                    </>
                  )}
                  <Button onClick={handleDownload} color="success">
                    <i className="mdi mdi-folder-download-outline"></i>{" "}
                    Descargar
                  </Button>{" "}
                  {role.id === idTransportista && (
                    <Button
                      style={{ padding: "0.5em" }}
                      title="Asociar Documento"
                      onClick={() => handleShowAssociateDocument()}
                      type="button"
                      color="light"
                    >
                      <IncloudIcon width="20px" /> {"   "}
                      Asociar Documento
                    </Button>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row>
                    <form onSubmit={formikFilter.handleSubmit}>
                      <Row>
                        <Col sm={3} md={3} lg={2}>
                          <Input
                            key={"Document_Number"}
                            onKeyDown={handleKeypress}
                            onChange={formikFilter.handleChange}
                            id="NroDocument"
                            name="NroDocument"
                            type="text"
                            value={formikFilter?.values?.NroDocument ?? ""}
                            placeholder="Ej.: 123456789, 45678912"
                          />
                        </Col>
                        <Col sm={3} md={3} lg={2}>
                          <Input
                            onChange={formikFilter.handleChange}
                            onKeyDown={handleKeypress}
                            id="ProviderName"
                            name="ProviderName"
                            type="text"
                            value={formikFilter.values?.ProviderName ?? ""}
                            placeholder="Proveedor"
                          />
                        </Col>
                        <Col sm={3} md={3} lg={2}>
                          <Input
                            onChange={formikFilter.handleChange}
                            onKeyDown={handleKeypress}
                            id="documentType"
                            name="documentType"
                            value={formikFilter.values?.documentType ?? ""}
                            placeholder="P. Insumo"
                          />
                        </Col>
                        <Col sm={3} md={3} lg={2}>
                          <Input
                            onChange={formikFilter.handleChange}
                            id="DateFrom"
                            name="DateFrom"
                            type="date"
                            value={formikFilter.values?.DateFrom ?? ""}
                            placeholder="Desde"
                          />
                        </Col>
                        <Col sm={3} md={3} lg={2}>
                          <Input
                            onChange={formikFilter.handleChange}
                            onKeyDown={handleKeypress}
                            id="DateTo"
                            name="DateTo"
                            type="date"
                            value={formikFilter.values?.DateTo ?? ""}
                            placeholder="Hasta"
                          />
                        </Col>
                        <Col sm={3} md={3} lg={2}>
                          <MultiSelect
                            key={filter?.StateId?.lenght ? 1 : 0}
                            onKeyDown={handleKeypress}
                            options={DocumentStatesOptions}
                            value={StateId}
                            onChange={setStateId}
                            overrideStrings={{
                              selectSomeItems: "Seleccione estado",
                              search: "Buscar",
                              noOptions: "Sin opciones",
                              allItemsAreSelected:
                                "Todos los items están seleccionados.",
                            }}
                            labelledBy={"Seleccione estado"}
                            hasSelectAll={false}
                            name="stateId"
                          />
                        </Col>
                        <Col
                          sm="12"
                          className="pt-2"
                          style={{ textAlign: "end" }}
                        >
                          <Button
                            className="btn btn-sm"
                            color="link"
                            onClick={() => {
                              handleClearFilter();
                              setCurrentPage(1);
                              getAll({
                                PageNumber: 1,
                                PageSize: pageSize,
                                orderColumn: SortOrder?.orderColumn,
                                orderType: SortOrder?.orderType,
                              });
                            }}
                          >
                            Limpiar
                          </Button>
                          <Button
                            className="btn btn-sm"
                            color="primary"
                            onClick={() => {
                              formikFilter.handleSubmit();
                            }}
                          >
                            Aplicar
                          </Button>
                        </Col>
                      </Row>
                      <Row></Row>
                    </form>
                  </Row>

                  <hr />

                  <div
                    classname="table table-responsive"
                    style={{ position: "relative" }}
                  >
                    {fetchingEyes && (
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          height: "100%",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          background: "#e7dbe770",
                          zIndex: 33,
                        }}
                      >
                        <Loader isLoading={fetchingEyes}></Loader>
                      </div>
                    )}

                    <BootstrapTable
                      key={"outbound_grid"}
                      remote={true}
                      pagination={paginationFactory({
                        ...PageOptions,
                        page: CurrentPage,
                      })}
                      columns={Columns(
                        handleView,
                        handleReactivarViaje,
                        handleControl,
                        handleValorizate,
                        handleActivate,
                        role,
                        handleOpenDocument,
                        handleDesasociarDocumento
                      )}
                      data={list?.data ?? []}
                      search={Search}
                      keyField={"id"}
                      responsive={true}
                      bordered={false}
                      striped={true}
                      onTableChange={handlePageChange}
                      classes={
                        "table align-middle table-nowrap table-sm tableResponsiveOutbound2"
                      }
                      headerWrapperClasses={"thead-light"}
                      noDataIndication={
                        <span className="no-data-message">
                          No hay datos disponibles
                        </span>
                      }
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <AsociarDocumentoGuardar
        ShowAssociateDocument={ShowAssociateDocument}
        setShowAssociateDocument={setShowAssociateDocument}
        handleClearAsociarDocumentoProcesar={
          handleClearAsociarDocumentoProcesar
        }
        transformedOptionsAsociarDocumento={transformedOptionsAsociarDocumento}
        SelectedDocumentNumber={SelectedDocumentNumber}
        setSelectedDocumentNumber={setSelectedDocumentNumber}
        inputFile={inputFile}
        handleFileChange={handleFileChange}
        setSelectedFile={setSelectedFile}
        handleAsociarDocumentoProcesar={handleAsociarDocumentoProcesar}
        getPageData2={getPageData2}
        currentPage2={currentPage2}
        pageSize2={pageSize2}
        ListAsociarDocumentoProcesar={ListAsociarDocumentoProcesar}
        sizePerPageList={sizePerPageList}
        handleSizePerPageChange2={handleSizePerPageChange2}
        handlePageChange2={handlePageChange2}
        handleOpenDocument2={handleOpenDocument2}
        handleSelectedtypeDocument={handleSelectedtypeDocument}
        ListTypeDocument={ListTypeDocument}
        fetching={fetching}
        handleGuardarAsociacionDocument={handleGuardarAsociacionDocument}
        setListAsociarDocumentoProcesar={setListAsociarDocumentoProcesar}
        ValidAsociarDocumento={ValidAsociarDocumento}
        assigned={assigned}
      />

      <AsignarAsociarDocuments
        ShowAsignarInbound={ShowAsignarInbound}
        setShowAsignarInbound={setShowAsignarInbound}
        transformedOptions={transformedOptions}
        SelectedAsociarDocumento={SelectedAsociarDocumento}
        setSelectedAsociarDocumento={setSelectedAsociarDocumento}
        handleAgregarAsociarDocumento={handleAgregarAsociarDocumento}
        getPageData3={getPageData3}
        handleRemoveDocumentoAsignado={handleRemoveDocumentoAsignado}
        ListAsociarDocumento={ListAsociarDocumento}
        currentPage3={currentPage3}
        pageSize3={pageSize3}
        sizePerPageList={sizePerPageList}
        handleSizePerPageChange3={handleSizePerPageChange3}
        handlePageChange3={handlePageChange3}
        handleProcesarAsociarDocumento={handleProcesarAsociarDocumento}
      />

      <ControlVisualPrincipal
        ShowOpenDocument={ShowOpenDocument}
        setShowOpenDocument={setShowOpenDocument}
        setSelectedObjectDocument={setSelectedObjectDocument}
        SelectedObjectDocument={SelectedObjectDocument}
        getPageData4={getPageData4}
        assignedForDocumentId={assignedForDocumentId}
        handlePageChange4={handlePageChange4}
        handleAceptarDocument={handleAceptarDocument}
        currentPage4={currentPage4}
        setCurrentPage4={setCurrentPage4}
        pageSize4={pageSize4}
        setPageSize4={setPageSize4}
        sizePerPageList={sizePerPageList}
        handleSizePerPageChange4={handleSizePerPageChange4}
        role={role}
        getRejectionReasonAll={getRejectionReasonAll}
        rejectionReason={rejectionReason}
      />

      <ControlVisualAsociarDoc
        setShowOpenDocument2={setShowOpenDocument2}
        ShowOpenDocument2={ShowOpenDocument2}
        SelectedObjectDocument2={SelectedObjectDocument2}
      />

      <ReactivarViaje
        ShowReactivarViaje={ShowReactivarViaje}
        setShowReactivarViaje={setShowReactivarViaje}
        SelectedReactivarViajeId={SelectedReactivarViajeId}
        postSaveReactive={postSaveReactive}
      />
      <DesasociarViaje
        ShowDesasociarViaje={ShowDesasociarViaje}
        setShowDesasociarViaje={setShowDesasociarViaje}
        SelectedDesasociarViajeId={SelectedReactivarViajeId}
        postSaveReactive={disassociateService}
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  list: state.Inbound?.list,
  totalCount: state.Inbound?.totalCount,
  selected: state.Inbound?.entity,
  users: state.Carriers.entities,
  role: state.Login?.user?.role ?? "guest",
  carrierCode: state.Login?.user?.user?.carrierCode,
  fetching: state.Inbound?.fetching,
  mustBeUpdated: state.Inbound?.mustBeUpdated,
  documentStates: state.Inbound?.states ?? [],
  rejecting: state.Inbound?.rejecting,
  rejected: state.Inbound?.rejected,
  filter: state.Inbound.filter,
  assigned: state.Inbound?.assigned,
  notassigned: state.Inbound?.notassigned,
  data: state.Inbound?.data,
  documentPageType: state?.Inbound?.documentPageType,
  documentProccess: state?.Inbound?.documentProccess,
  assignedForDocumentId: state?.Inbound?.assignedForDocumentId,
  fetchingEyes: state?.Inbound?.fetchingEyes,
  rejectionReason: state?.Inbound?.rejectionReason
});

const mapDispatchToProps = (dispatch) => {
  return {
    getAll: (filter) =>
      dispatch({ type: inboundActionTypes.GET_ALL, payload: filter }),
    download: (filter) =>
      dispatch({ type: inboundActionTypes.DOWNLOAD, payload: filter }),
    reject: (id) => dispatch({ type: inboundActionTypes.REJECT, payload: id }),
    getAllDocumentsSTates: (filter) =>
      dispatch({ type: inboundActionTypes.GET_ALL_STATES, payload: filter }),
    setFilter: (filter) =>
      dispatch({ type: inboundActionTypes.SET_FILTER, payload: filter }),
    clearFilter: (filter) =>
      dispatch({ type: inboundActionTypes.CLEAR_FILTER }),
    getAllAssigned: (filter) =>
      dispatch({ type: inboundActionTypes.GET_ALL_ASSIGNED, payload: filter }),
    getAllNotAssigned: () =>
      dispatch({ type: inboundActionTypes.GET_ALL_NOTASSIGNED }),
    postSaveAssigned: (data) =>
      dispatch({ type: inboundActionTypes.SAVEASSIGNED, payload: data }),
    getAllPageType: () => dispatch({ type: inboundActionTypes.GET_ALL_PAGETYPE }),
    getRejectionReasonAll: (data) =>
      dispatch({
        type: inboundActionTypes.GET_ALL_REJECTION_REASON,
        payload: data,
      }),
    fetchProccess: (data) =>
      dispatch({ type: inboundActionTypes.GET_ALL_PROCCESS, payload: data }),
    postSaveAttachs: (data) =>
      dispatch({ type: inboundActionTypes.SAVEATTACHS, payload: data }),

    postSaveApproval: (data) =>
      dispatch({ type: inboundActionTypes.SAVEAPROVAL, payload: data }),

    postSaveReactive: (data) =>
      dispatch({ type: inboundActionTypes.SAVEREACTIVE, payload: data }),

    getAllAssignedForDocumentId: (data) => {
      return dispatch({
        type: inboundActionTypes.GET_ALL_ASSIGNED_FOR_DOCUMENTID,
        payload: data,
      });
    },
    exportAllDocument: (filter) =>
      dispatch({ type: inboundActionTypes.ALLEXPORT, payload: filter }),

    disassociateService: (data) =>
      dispatch({ type: inboundActionTypes.DISSASOCIATE, payload: data }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(List);
